module.exports = __webpack_public_path__ + "img/neutral.8e13e44d.png";